import styled, { css } from 'styled-components';

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  left: 0;

  &:checked ~ span {
    border: 1px solid ${props => props.theme.colors.brownGrey};
  }

  &:checked ~ span:after {
    display: block;
    background: ${props => props.theme.colors.white};
  }
`;

const CustomRadio = styled.span`
  position: absolute;
  left: 0;
  width: 15px;
  height: 15px;
  background-color: ${props => props.theme.colors.black};
  border: 1px solid ${props => props.theme.colors.brownGrey};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    display: none;
    width: 9px;
    height: 9px;
    border-radius: 100%;
    display: block;
  }
`;

const Label = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #acacac;
  margin: 0;
  padding-left: 1.3rem;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  padding-left: 30px;

  @media ${props => props.theme.device.mobileL} {
    margin-top: 10px;
  }
  
  ${({ isToj }) => isToj && css`
     color: ${props => props.theme.colors.primaryThemeBlue};
     ${Input} {
      &:checked ~ span:after {
        display: block;
        background: ${props => props.theme.colors.primaryThemeBlue};
      }
     } 
  `}
`;

export { Label, Input, CustomRadio };
